export default __webpack_public_path__ + "static/media/ic-pdf.0c5a2345.svg";